import { CommonModule } from '@angular/common';
import { AfterContentChecked, AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/Service/event.service';
import { RollCallService } from 'src/app/Service/roll-call.service';
import * as Lmap from 'leaflet';
import { utilsApps } from 'src/app/helpers/utils-app';
import { event } from 'jquery';
import { EmiMapComponent } from "../../../shared/emi-map/emi-map.component";
import { items } from 'fusioncharts';
@Component({
  selector: 'emi-modal-detail-register',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, MatFormFieldModule, MatInputModule, MatIconModule, TranslateModule, MatDatepickerModule, MatSelectModule, EmiMapComponent],
  templateUrl: './modal-detail-register.component.html',
  styleUrls: ['./modal-detail-register.component.css']
})
export class ModalDetailRegisterComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() dataRegister: any = {};
  @Output() action = new EventEmitter<any>();
  public localDataRegister: any = {};

  constructor(private readonly translateService: TranslateService,
    private readonly eventService: EventService,
    private readonly sanitizer: DomSanitizer,
    private readonly rollCallService: RollCallService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

  }

  async ngOnChanges() {
    this.localDataRegister = this.dataRegister;
    await this.getDataRegister(this.localDataRegister.contextual);
    await this.getDataValidationEvent(this.localDataRegister.contextual);

    const validationRegister = this.localDataRegister.validation || this.localDataRegister.validations || [];
    if (validationRegister && validationRegister.length > 0) {
      if (this.localDataRegister.source !== 'provider') {
        const validation = validationRegister.find(item => item.type === 'match.location');
        if (validation.status === "wrong") {
          await this.onGetCoordinatesWrong(this.localDataRegister.contextual);
        }
      }
    }

  }

  ngOnDestroy(): void {
  }

  public onClose() {
    this.action.emit({ event: 'close', data: null });
  }

  public async onDownloadFile(typeObject: string) {
    let object: any;
    let name: string;
    switch (typeObject) {
      case "document":
        object = await this.getDataObject(this.localDataRegister.document, "document");
        name = 'Document';
        break;
      case "evidence":
        object = await this.getDataObject(this.localDataRegister.evidence, "image");
        name = 'Evidence';
        break;
      case "selfie":
        object = await this.getDataObject(this.localDataRegister.face, "image");
        name = 'Selfie';
        break;
    }


    if (object) {
      const objectUrl = URL.createObjectURL(object);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = name;
      link.click();

      // Liberar la URL de objeto
      URL.revokeObjectURL(objectUrl);
      console.log(objectUrl);
    } else {
      this.eventService.errorMessage(0, 'common.error500');
    }
  }


  public async onViewFile(typeObject: string) {
    let object: any;
    let name: string;
    switch (typeObject) {
      case "document":
        object = await this.getDataObject(this.localDataRegister.document, "document");
        name = 'Document';
        break;
      case "evidence":
        object = await this.getDataObject(this.localDataRegister.evidence, "image");
        name = 'Evidence';
        break;
      case "selfie":
        object = await this.getDataObject(this.localDataRegister.face, "image");
        name = 'Selfie';
        break;
    }
    if (object) {
      const objectUrl = URL.createObjectURL(object);
      let urlSafety = null;
      if (typeObject === "selfie" || typeObject === "evidence") {
        urlSafety = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      } else {
        urlSafety = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      }

      this.action.emit({ event: 'viewFile', data: { type: typeObject, url: urlSafety } });
    } else {
      this.eventService.errorMessage(0, 'common.error500');
    }

  }


  private async getDataRegister(idObject: string) {
    try {
      this.eventService.startLoadingData();
      const response = await this.rollCallService.getDataUser(idObject);
      if (response && response.code === "SUCCESS") {
        //Convert the response to a JSON object
        const dataInformation = JSON.parse(response.content);
        this.localDataRegister = dataInformation;

      } else {
        this.eventService.errorMessage(0, 'common.error500');
      }
    } catch (error) {
      this.eventService.errorMessage(0, 'common.error500');
    } finally {
      this.eventService.completeLoadingData();
    }
  }

  private async getDataValidationEvent(idEvent: string) {
    try {
      this.eventService.startLoadingData();
      const response = await this.rollCallService.getAllValidationEvent(idEvent);
      if (response && response.code === "SUCCESS") {
        const dataValidation = JSON.parse(response.content);
        this.localDataRegister.validation = this.getFormatValidation(dataValidation);
        console.log(this.localDataRegister);
      } else {
        this.eventService.errorMessage(0, 'common.error500');
      }
    } catch (error) {
      this.eventService.errorMessage(0, 'common.error500');
    } finally {
      this.eventService.completeLoadingData();
    }
  }

  private getFormatValidation(dataValidation: any) {
    if (dataValidation && dataValidation.records.length > 0) {
      let data: any;
      data = dataValidation.records.filter(item => (item.type === "match.face" || item.type === "liveness.face" || item.type === "match.location"));
      if (this.localDataRegister.source === 'provider') {
        data = dataValidation.records.filter(item => (item.type === "match.face" || item.type === "liveness.face"));
      }
      //Agregamos el detalle de la validación
      data.forEach((item: any) => {
        switch (item.type) {
          case 'match.face':
          default:
            if (item.detail === 'MATCH') {
              item.detail = 'rollCall.validationResponse.successValidationMatch';
            } else {
              item.detail = 'rollCall.validationResponse.errorValidationMatch';
            }
            break;
          case 'liveness.face':

            if (item.detail === 'APPROVED') {
              item.detail = 'rollCall.validationResponse.successValidationLiveness';
            } else {
              item.detail = 'rollCall.validationResponse.errorValidationLiveness';
            }

            break;
          case 'match.location':
            if (item.detail === 'IN') {
              item.detail = 'rollCall.validationResponse.successValidationLocation';
            } else {
              if (item.detail === 'OUT') {
                item.detail = 'rollCall.validationResponse.errorValidationLocationOut';
              } else {
                item.detail = 'rollCall.validationResponse.errorValidationLocation';
              }

            }
            break;
        }
      });
      return data;
    }
    return [];
  }


  private async getDataObject(idObject: string, typeObject: string) {
    try {
      const response: any = await this.rollCallService.getDataObject(idObject);
      if (response && response.code === "SUCCESS") {
        //Convert the response to a JSON object
        const getDataObject = response.content;
        let file: any;
        switch (typeObject) {
          case "image":
            file = this.b64toBlob(getDataObject, 'image/jpeg');
            break;
          case "document":
            file = this.b64toBlob(getDataObject, 'application/pdf');
            break;
          default:
            file = null;
            break;
        }
        return file;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public async onValidateManual(validation: any) {
    try {
      this.eventService.startLoadingData();
      const request = {
        reference: validation.eventId,
        validations: [
          validation.type
        ]
      }
      const response = await this.rollCallService.setValidationManual(request);
      if (response && response.code === "SUCCESS") {
        this.eventService.successMessage(3, 'Intento de validacion realizado correctamente');
        this.getDataValidationEvent(this.localDataRegister.contextual);
        //this.action.emit({ event: 'close', data: null });
      } else {
        this.eventService.errorMessage(1);
      }
    } catch (error) {
      this.eventService.errorMessage(0, 'common.error500');
    } finally {
      this.eventService.completeLoadingData();
    }
  }


  public async onGetCoordinatesWrong(idEvent: any) {
    try {
      const response = await this.rollCallService.getCoordinatesWrong(idEvent);
      if (response && response.code === "SUCCESS") {
        const data = JSON.parse(response.content);
        this.localDataRegister.locationWrong = {
          referenceGeolocation: data.referenceGeolocation,
          sourceGeolocation: data.sourceGeolocation,
        };
      } else {
        this.eventService.errorMessage(0, 'common.error500');
      }
    } catch (error) {
      this.eventService.errorMessage(0, 'common.error500');
    }
  }


}
